<template lang="pug">
  #app
    router-view
</template>

<script>
export default {
  components: {},
  mounted() {
    console.log(`
    ............................................................
    ............................................................
    ........................-/+osssso/:.........................
    ....................-/osyyyysssyyyyyo/-.....................
    .................-/syyyys/-.    .:+syyys+:..................
    ..............:osyyyyo:.            -/syyyyo/...............
    ..........-/oyyyys/-.    .-:::.        .:oyyyys+-...........
    ......../syyyyo:.       :sssssso/-.       .-/syyyo:.........
    ......:oyyy+-.         .sss/-/ossss+:.        .+yyy+........
    ....::oyyy-            .sss:   .:+sssso/-.      -yyy+.......
    ..://:yyy+             .sss:.:///-.-/ossss+:.    :yyy-......
    :////:yyy/             .sssssssssso.  .:+sssso:. .yyy/......
    /////:yyy/           .:+sssso:..oss/     .-/sss+  yyy/......
    /////:yyy/       .-/ossssss:    oss/      .:osso  yyy/......
    ::::::yyy/    .:+ossso/-sss:    oss/   ./ossss+.  yyy/......
    :::::/yyy/  -ossso+:.  .sss:    oss+-+sssso/-.    yyy/......
    :::::/yyy/ .sss/-.     .sss:    osssssso:.        yyy/......
    :::::/yyy/ .oss+:.     .sss:.-/ossss/-.           yyy/......
    ---::/yyy/  ./ossso/.   /ssssssssss/              yyy/......
    -::::/syy+    .-/ossso+-../++/-.oss/             .yyy/......
    //:::/+yyy:       .:+ossso:.    oss/            .+yys.......
    //////:oyyy+-        .-/ossso/-.oss/          .:syys-.......
    /////:::/syyys+-.        .:+sssssso.       ./oyyyy+.........
    /////:-:::/+syyyyo/.        .-//:-     .-+syyyyo/...........
    /////:----:://+syyyys+-.            .:oyyyyso+:.............
    /////:--::::/:///+osyyyyo:.     .-/syyyys+//:-..............
    ::::::///:::/:::::::/osyyyysooosyyyyso+:/::.................
    :::::////////:::::://///+ossyyyysoo/////:...................
    :::::////////::::::////////:::::::////:-....................
    :::::///////:-:::::///////:--:::::///-......................

    Data Cívica
    Más datos para más personas

    info@datacivica.org
    https://datacivica.org
    https://twitter.com/datacivica
    https://facebook.com/datacivica
    https://instagram.com/datacivica
    https://youtube.com/datacivica
    https://t.me/datacivica
    `);
  }
};
</script>

<style lang="scss">
#modal.soon {
  .modal-dialog .modal-content {
    //width: 50%;
    background-color: rgba(76, 73, 155, 0.8) !important;
    border-radius: 4px;
    color: white;
    font-family: "Inria Sans", sans-serif;
    i {
      float: right;
      cursor: pointer;
    }
    p {
      text-align: center;
    }
  }
}
</style>
